/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * StarHalfIcon
 */
export default class StarHalfIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M23 9c-.1-.4-.4-.6-.8-.7l-6.4-.9-2.9-5.8c-.2-.4-.5-.6-.9-.6s-.7.2-.9.6L8.2 7.4l-6.3.9c-.4.1-.7.3-.9.7-.2.4 0 .8.3 1l4.6 4.4-1.1 6.4c-.1.4.1.8.4 1 .3.2.7.3 1.1.1l5.7-3 5.7 3c.2.1.3.1.5.1s.4-.1.6-.2c.3-.2.5-.6.4-1l-1.1-6.4 4.6-4.4c.3-.2.4-.6.3-1zm-6.7 4.4c-.2.2-.3.6-.3.9l.9 4.9-4.4-2.3c-.067-.067-.233-.1-.5-.1V4.3l2.2 4.5c.1.2.4.4.8.5l4.9.7-3.6 3.4z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

